import * as types from "./types"

// export * from "./lists"

export const initApplication = () => ({
  type: types.INIT_APPLICATION
})
